import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Link, Slide, Skeleton } from "@mui/material";
import axios from "axios";
import { Close } from "@mui/icons-material";
import MemberService from "../../services/MemberService";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function OrgTermsOfService({ children, underline }) {
    const termsOfServiceContent = useRef("");
    const [termsOfServiceUrl, setTermsOfServiceUrl] = useState("");
    const [hasContent, setHasContent] = useState(false);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    
    useEffect(() => {
        const source = axios.CancelToken.source();
        
        // First, try to get Terms of Service content
        MemberService.getTermsOfService(source.token)
            .then(content => {
                if (content && content.trim() !== "") {
                    // Has content - use modal behavior
                    termsOfServiceContent.current = content;
                    setHasContent(true);
                } else {
                    // No content - fall back to link behavior
                    setHasContent(false);
                    return MemberService.getTermsOfServiceLink(source.token);
                }
            })
            .then(url => {
                if (!hasContent && url) {
                    setTermsOfServiceUrl(url);
                }
            })
            .catch(contentError => {
                if (!axios.isCancel(contentError)) {
                    // Terms of Service content not found, try Terms of Service Link
                    setHasContent(false);
                    return MemberService.getTermsOfServiceLink(source.token)
                        .then(url => {
                            if (url && url.trim() !== "") {
                                setTermsOfServiceUrl(url);
                            } else {
                                setTermsOfServiceUrl("");
                            }
                        })
                        .catch(linkError => {
                            if (!axios.isCancel(linkError)) {
                                console.error("Neither terms of service content nor link available:", linkError);
                                // Neither content nor link available
                                setTermsOfServiceUrl("");
                            }
                        });
                }
            });
            
        return function cleanup() {
            source.cancel();
        };
    }, []);

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        if (open && hasContent) {
            setIsLoading(true);
            // Fetch terms of service content for modal display
            MemberService.getTermsOfService(source.token)
                .then(content => {
                    termsOfServiceContent.current = content;
                    setIsLoading(false);
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        console.error("Error loading terms of service content:", error);
                        termsOfServiceContent.current = "Failed to load Terms of Service. Please try again later.";
                        setIsLoading(false);
                    }
                });

            return function cleanup() {
                source.cancel();
            }
        }
    }, [open, hasContent])

    if (hasContent) {
        // Modal behavior for Terms of Service content
        return (
            <React.Fragment>
                <Link underline={underline || "always"} onClick={handleOpen}>
                    {children || "Terms of Service"}
                </Link>
                <Dialog 
                    open={open}
                    scroll="paper"
                    onClose={handleClose}
                    TransitionComponent={Transition}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>
                        Terms of Service
                        <IconButton
                            size="large"
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>                    
                        {isLoading ? (
                            <>
                                <Skeleton variant="rectangular" width="50%" style={{ marginBottom: 6 }}/>
                                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: 6 }}/>
                                <Skeleton variant="rectangular" width="75%" style={{ marginBottom: 6 }}/>
                            </>
                        ) : (
                            <div dangerouslySetInnerHTML={{ __html: termsOfServiceContent.current }} />
                        )}
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    } else {
        // Link behavior (fallback to Terms of Service Link)
        return (
            <Link 
                underline={underline || "always"}
                target="_blank"
                rel="noreferrer"
                href={termsOfServiceUrl || "#"}
            >
                {children || "Terms of Service"}
            </Link>
        );
    }
}

export default OrgTermsOfService;
